'use strict';

require('../../style/index.less');

require('../../grid/style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/col/style/index.tsx
 ** module id = 574
 ** module chunks = 0
 **/